import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { WagmiProvider } from 'wagmi';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
// import { RainbowKitProvider } from '@rainbow-me/rainbowkit';
import { AuthProvider } from './contexts/AuthContext';
import { MessageProvider } from './contexts/MessageContext';
import { MessageContainer } from './components/Message';
import { NotificationProvider } from './contexts/NotificationContext';
import { config } from './config/wagmi';
import Layout from './components/Layout';
import HomePage from './pages/HomePage';
import UserProfile from './pages/UserProfile';
import Settings from './pages/Settings';
import MyPredictions from './pages/MyPredictions';
import ClaimPlyp from './pages/ClaimPlyp';
import Documentation from './pages/Documentation';
import TermsOfUse from './pages/TermsOfUse';
import CoinDetail from './pages/CoinDetail';
import NotificationPage from './pages/NotificationPage';
import LeaderboardPage from './pages/LeaderboardPage';
import NetworkStatus from './components/NetworkStatus';

// import '@rainbow-me/rainbowkit/styles.css';

const queryClient = new QueryClient();

function App() {
  return (
    <WagmiProvider config={config}>
      <QueryClientProvider client={queryClient}>
        <div>
          <MessageProvider>
            <NotificationProvider>
              <AuthProvider>
              <Router>
                <Routes>
                  <Route path="/" element={
                    <Layout>
                      <HomePage />
                    </Layout>
                  } />
                  <Route path="/profile" element={
                    <Layout>
                      <UserProfile />
                    </Layout>
                  } />
                  <Route path="/settings" element={
                    <Layout>
                      <Settings />
                    </Layout>
                  } />
                  <Route path="/predictions" element={
                    <Layout>
                      <MyPredictions />
                    </Layout>
                  } />
                  <Route path="/claim" element={
                    <Layout>
                      <ClaimPlyp />
                    </Layout>
                  } />
                  <Route path="/docs" element={
                    <Layout>
                      <Documentation />
                    </Layout>
                  } />
                  <Route path="/terms" element={
                    <Layout>
                      <TermsOfUse />
                    </Layout>
                  } />
                  <Route path="/coin/:symbol" element={
                    <Layout>
                      <CoinDetail />
                    </Layout>
                  } />
                  <Route path="/notifications" element={
                    <Layout>
                      <NotificationPage />
                    </Layout>
                  } />
                  <Route path="/leaderboard" element={
                    <Layout>
                      <LeaderboardPage />
                    </Layout>
                  } />
                </Routes>
              </Router>
              {/* Global Message Container */}
              <MessageContainer />
              {/* Network Status Monitor */}
              <NetworkStatus />
              </AuthProvider>
            </NotificationProvider>
          </MessageProvider>
        </div>
      </QueryClientProvider>
    </WagmiProvider>
  );
}

export default App;
